import { usePremiumFeatureAllowed as _usePremiumFeatureAllowed } from '@griply/hooks';
import { LimitCheckFunctionParams } from '@griply/utils';
import { useToday } from 'shared/contexts/today';
import { LimitKeys } from 'shared/types/limit-keys';

import { useUser } from './use-user';

export const usePremiumFeatureAllowed = <LimitKey extends LimitKeys>(
  limitKey: LimitKey,
  options: Omit<LimitCheckFunctionParams[LimitKey], 'user' | 'today'>,
) => {
  const today = useToday();
  const user = useUser();

  return _usePremiumFeatureAllowed(limitKey, options, { user, today });
};
